import { Provider } from "@/components/excel/schema/definiens/provider";
import { SexOption } from "@/components/excel/schema/label/type/other";
import { buildCommonProvider } from "@/components/excel/schema/label/provider/base";

export const OtherNameProvider: { [key: number]: Provider } = {
  ...buildCommonProvider(SexOption),
};
